export default __webpack_public_path__ + "static/media/discharged.3b1a903f.svg";